import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import stage from '../components/stage'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class Modal extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    
    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0

    


    this.ref = {
      location: []
    }

  }

  mount() {

    this.modal = document.getElementById('modal')
    this.iframe = document.getElementById('modal__iframe')
    
    $('[data-button]').on('click', (e)=>{
        this.close()
    })

    _each(this.ref.location, (item) => {

      
      $(item).on('click', (e) => {
        e.preventDefault()

        const loc = item.dataset.location
        
        this.show(loc)
      
      })
      

    })

      
}


show(loc) {

  lenis.stop()
  this.iframe.src = loc
  this.modal.classList.remove('has-overlay')


}

close(){
  lenis.start();
  this.modal.classList.remove('is-opened', 'has-overlay')
  this.iframe.src = ""
}



resize(){
  
}

  unmount() {

_each(this.ref.location, (item) => {

  $(item).off('click')
})


$('[data-button]').off('click')

  }


}

module.exports = Modal
